export const getSlug = (title) => {
  return !title
    ? ''
    : title
        .replace(/-/g, ' ')
        .replace(/  +/g, ' ')
        .replace(/&/g, 'and')
        .replace(/ /g, '-')
        .replace(/[^A-Za-z0-9-]/g, '')
        .toLowerCase();
};

export default getSlug;
